export default __webpack_public_path__ + "static/gi_swpa_2c_cmyk.png";